import SearchNaverResultItemSkeleton from './SearchNaverResultItemSkeleton';

const SKELETON_WIDTHS = ['w-48', 'w-40', 'w-56', 'w-44', 'w-52'];

const SearchNaverResultListSkeleton = () => {
	return (
		<section className="flex w-full flex-col">
			<ul className="w-full">
				{SKELETON_WIDTHS.map((titleWidthClassName) => (
					<SearchNaverResultItemSkeleton
						key={titleWidthClassName}
						titleWidthClassName={titleWidthClassName}
					/>
				))}
			</ul>
		</section>
	);
};

export default SearchNaverResultListSkeleton;
